// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2R8Or","legacyBtn":"MutateMid_legacyBtn__17Zbs"};